<template>
    <v-main :style="{background: theme.espotoYellow}">
      <v-container class="containerText">
        <v-layout text-center>
          <v-flex>
            <div class="mt-5 pa-1 text-left">
              AGBs
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'

export default {
  mixins: [layoutMixin],
  computed: {
  }
}
</script>
<style scoped>
a{
  overflow-wrap: break-word;
}
.containerText{
  max-width: 70%;
}
</style>
